/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Joinus1Inputs */

const ja_nav_joinus1 = /** @type {(inputs: Nav_Joinus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`採用情報`)
};

const en_nav_joinus1 = /** @type {(inputs: Nav_Joinus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JOIN US`)
};

/**
* | output |
* | --- |
* | "JOIN US" |
*
* @param {Nav_Joinus1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const nav_joinus1 = /** @type {((inputs?: Nav_Joinus1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Joinus1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_joinus1(inputs)
	return en_nav_joinus1(inputs)
});
export { nav_joinus1 as "nav_joinUs" }